import { useEffect } from "react";
import { CardWrapper } from "../../components/CardWrapper/CardWrapper";
import { ContentWrapper } from "../../components/ContentWrapper/ContentWrapper";
import { ErrorSnackbar } from "../../components/ErrorSnackbar/ErrorSnackbar";
import { Loader } from "../../components/Loader/Loader";
import { PageTitleBlock } from "../../components/PageTitleBlock/PageTitleBlock";
import { useDispatch, useSelector } from "../../hooks";
import styles from "./AchievementsPage.module.scss";
import { getAchievements } from "../../redux/achievements/get-achievements.handler";
import { AchievementCard } from "../../components/AchievementCard/AchievementCard";

export const AchievementsPage = () => {
    const dispatch = useDispatch();
    const { items: achievements, loading, error } = useSelector(store => store.achievements);

    useEffect(() => {
        dispatch(getAchievements());
    }, [dispatch]);
    
    return (
        <>
            <ContentWrapper>
                <div className={styles.wrapper}>
                    <PageTitleBlock pageTitle="Достижения" />

                    <CardWrapper>
                        {achievements.map((achievement, index) => (
                            <AchievementCard
                                key={ `achievement${index}` }
                                { ...achievement }
                            />
                        ))}
                    </CardWrapper>
                </div>
            </ContentWrapper>

            { loading && <Loader /> }
            { error.length > 0 && <ErrorSnackbar errorMessage={ error } /> }
        </>
    )
}